import React, {Component} from "react";
import {connect} from "react-redux";

class UserData extends Component {
	render() {
		const {user} = this.props;
		const info = user.info;

		return (
			<div>
				<div className="profile__header userdata__header">
					<div>Личные данные</div>
					<div>Документ, удостоверяющий личность</div>
				</div>

				<form id="userdata_form" method="post" action="">
					<div className="userdata">
						<div className="userdata__left">
							<div>Логин</div>
							<input type="text" name="login" value={info.login} disabled/>

							<div>ФИО</div>
							<input type="text" name="fio" value={`${info.last_name} ${info.first_name} ${info.middle_name}`} disabled/>

							<div>Дата рождения</div>
							<input type="date" value={`${info.birthday}`} disabled/>

							<div>Эл. почта</div>
							<input type="email" name="email" value={info.email} disabled/>
						</div>
						<div className="userdata__right">
							<div>Серия и номер паспорта</div>
							<input type="text" name="passport" value={`${info.passport}`} disabled/>

							<div>Кем выдан</div>
							<input type="text" name="who" value={`${info.iwho}`} disabled/>

							<div>Дата выдачи</div>
							<input type="date" value={`${info.iwhen}`} disabled/>

							<div>Город</div>
							<input type="text" name="city" value={`${info.address}`} disabled/>
						</div>
					</div>
				</form>
			</div>
		);
	}
}

export default connect(
	state => ({
		user : state.user
	}),
	dispatch => ({})
)(UserData);


// WEBPACK FOOTER //
// ./src/app/pages/User/UserData.js